import { api } from "../Configurations/axios";
import { InnovationHistoricFinepModel } from "../Models/InnovationHistoricFinepModel";

const GetInnovationByRegistrationDocumentsIdAPI = async (id: string) => {
    try {
        var result = await api.get(`/innovationHistoricFinep/GetByRegistrationDocumentsId/${id}`);
        var response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const PostInnovationHistoricFinepAPI = async (data: InnovationHistoricFinepModel) => {
    try {
        var result = await api.post('/innovationHistoricFinep/Post', data);
        var response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const PutInnovationHistoricFinepAPI = async (data: InnovationHistoricFinepModel) => {
    try {
        var result = await api.put('/innovationHistoricFinep/Put', data);
        var response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

export {
    GetInnovationByRegistrationDocumentsIdAPI,
    PostInnovationHistoricFinepAPI,
    PutInnovationHistoricFinepAPI
}